import { Controller } from "stimulus";

export default class extends Controller {

  static get targets() {
    return [
      'button',
      'subOpenButton',
      'subCloseButton',
      'content',
      'mainContent',
      'subContent',
    ];
  }

  initialize() {
    this.siteHeaderRoot = document.querySelector('#site-header');
    this.mediaQuery = this.element.dataset.desktopSize;

    if (this.mediaQuery) {
      this.watchMediaQuery();
    }
  }

  watchMediaQuery() {
    const mediaQuery = window.matchMedia(`(min-width: ${this.mediaQuery})`);
    mediaQuery.addEventListener('change', () => {
      this.closeAll()
    });
  }

  toggle(e) {
    const button = e.currentTarget;
    const isOpen = button.getAttribute('aria-expanded') === 'true';

    if (!isOpen) {
      this.closeAll();
    }
    button.setAttribute('aria-expanded', !isOpen);
    this.siteHeaderRoot.classList.toggle('is-open', !isOpen);
  }

  toggleSub(e) {
    const button = e.currentTarget;

    const index = Math.max(this.findTargetElementIndex(button, this.subOpenButtonTargets), this.findTargetElementIndex(button, this.subCloseButtonTargets));
    const openButton = this.subOpenButtonTargets[index];
    const isOpen = openButton.getAttribute('aria-expanded') === 'true';

    openButton.setAttribute('aria-expanded', !isOpen);
    // if not open, opening = add overflow  hide= true
    // if open, closing = remove overflow hide = false

    this.toggleMainNavOverflow(!isOpen);
  }

  hide(e) {
    const buttonIndex = this.findTargetElementIndex(e.target, this.buttonTargets);
    const contentIndex = this.findTargetElementIndex(e.target, this.contentTargets);

    if (buttonIndex < 0 && contentIndex < 0) {
      this.closeAll();
    }
  }

  esc(e) {
    if (e.which === 27) {
      this.closeAll();
    }
  }

  closeAll() {
    this.siteHeaderRoot.classList.remove('is-open');

    this.buttonTargets.forEach(element => {
      element.setAttribute('aria-expanded', 'false');
    });
    this.subOpenButtonTargets.forEach(element => {
      element.setAttribute('aria-expanded', 'false');
    });
    if (this.hasMainContentTarget) {
      this.toggleMainNavOverflow(false);
    }
  }

  findTargetElementIndex(targetElement, targetArray) {
    return targetArray.findIndex(target => target.contains(targetElement));
  }

  toggleMainNavOverflow(isAddClass = undefined) {
    this.mainContentTarget.scrollTo(0, 0);
    this.mainContentTarget.classList.toggle('overflow-y-hidden', isAddClass);
  }
};